import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './Cloud.css';

const Cloud = () => {
  const plans = [
    {
      name: "סטנדרטי",
      specs: {
        cpu: "ליבה 1",
        ram: "זיכרון RAM: 2GB",
        storage: "אחסון: 100GB SSD",
        bandwidth: "רוחב פס: 20Mbps",
        traffic: "תעבורה: ללא הגבלה"
      },
      price: "219 ₪"
    },
    {
      name: "עסקי",
      specs: {
        cpu: "2 ליבות",
        ram: "זיכרון RAM: 4GB",
        storage: "אחסון: 100GB SSD",
        bandwidth: "רוחב פס: 20Mbps",
        traffic: "תעבורה: ללא הגבלה"
      },
      price: "439 ₪"
    },
    {
      name: "מתקדם",
      specs: {
        cpu: "4 ליבות",
        ram: "זיכרון RAM: 8GB",
        storage: "אחסון: 200GB SSD",
        bandwidth: "רוחב פס: 50Mbps",
        traffic: "תעבורה: ללא הגבלה"
      },
      price: "699 ₪"
    }
  ];

  const features = [
    "ניהול מלא",
    "גיבוי Snapshot",
    "גיבוי לענן מרוחק (7 ימים)",
    "עדכונים ועדכוני אבטחה",
    "ניטור שרת",
    "תמיכה בתשתית",
    "ייעוץ טכני",
    "תעודת SSL",
    "מערכת הגנת סייבר",
  ];

  // Add structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "שירות ענן היברידי מנוהל",
    "description": "פתרון ענן היברידי מנוהל המשלב בין היתרונות של ענן פרטי לענן ציבורי, עם ניהול מלא וביצועים מעולים",
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "ILS",
      "lowPrice": "219",
      "highPrice": "699",
      "offerCount": "3"
    }
  };

  // Add PayPal script load handler
  useEffect(() => {
    let scriptElement = null;
    
    const loadPayPalScript = () => {
      if (scriptElement) {
        document.body.removeChild(scriptElement);
      }

      scriptElement = document.createElement('script');
      scriptElement.src = `https://www.paypal.com/sdk/js?client-id=AdWIx81WbV4y0eGSaVvcJ46FVo9-eSxz1Ao2rOy0glrPDdU_343yTk4xYg_NxffTknRiAbaYbNByFNcf&vault=true&intent=subscription&locale=he_IL`;
      scriptElement.setAttribute('data-sdk-integration-source', 'button-factory');
      scriptElement.async = true;

      scriptElement.onload = () => {
        console.log('PayPal script loaded successfully');
        initializePayPalButtons();
      };

      scriptElement.onerror = (error) => {
        console.error('Error loading PayPal script:', error);
      };

      document.body.appendChild(scriptElement);
    };

    loadPayPalScript();

    return () => {
      if (scriptElement && document.body.contains(scriptElement)) {
        document.body.removeChild(scriptElement);
      }
    };
  }, []);

  const initializePayPalButtons = () => {
    if (!window.paypal) {
      console.log('PayPal not loaded yet');
      return;
    }

    try {
      const buttonConfigs = [
        {
          containerId: '#paypal-button-container-P-40696904NP245520GM6RGYYY',
          planId: 'P-40696904NP245520GM6RGYYY'
        },
        {
          containerId: '#paypal-button-container-P-9Y5799824B107742KM6RG5LY',
          planId: 'P-9Y5799824B107742KM6RG5LY'
        },
        {
          containerId: '#paypal-button-container-P-30208148FW311183BM6RG6PQ',
          planId: 'P-30208148FW311183BM6RG6PQ'
        }
      ];

      buttonConfigs.forEach(config => {
        const container = document.querySelector(config.containerId);
        if (container) {
          window.paypal.Buttons({
            style: {
              shape: 'rect',
              color: 'blue',
              layout: 'vertical',
              label: 'subscribe'
            },
            createSubscription: function(data, actions) {
              return actions.subscription.create({
                plan_id: config.planId
              });
            },
            onApprove: function(data, actions) {
              alert(data.subscriptionID);
            },
            onError: function(err) {
              console.error('PayPal button error:', err);
            }
          }).render(config.containerId);
        }
      });
    } catch (error) {
      console.error('Error initializing PayPal buttons:', error);
    }
  };

  return (
    <>
      <Helmet>
        <title>שירות ענן היברידי מנוהל | EpicFinal</title>
        <meta name="description" content="שירות ענן היברידי מנוהל המשלב בין היתרונות של ענן פרטי לענן ציבורי. פתרון מושלם לעסקים המחפשים גמישות, אבטחה וביצועים מעולים." />
        <meta name="keywords" content="ענן היברידי, שירותי ענן, אחסון ענן, שרתים מנוהלים, ענן פרטי, ענן ציבורי, אבטחת מידע" />
        <meta property="og:title" content="שירות ענן היברידי מנוהל | EpicFinal" />
        <meta property="og:description" content="פתרון ענן היברידי מנוהל המשלב בין היתרונות של ענן פרטי לענן ציבורי, עם ניהול מלא וביצועים מעולים" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="he_IL" />
        <link rel="canonical" href="https://epicfinal.com/cloud" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <main className="cloud-page">
        <div className="cloud-container">
          <div className="hero-section">
            <h1>שירות ענן היברידי מנוהל – פתרון הענן המושלם לצמיחה העסקית שלך</h1>
            <div className="cloud-intro">
              <p>בעידן הדיגיטלי המתקדם של היום, לעסקים אין זמן או משאבים להשקיע בבנייה ותחזוקה של תשתיות ענן מורכבות. כאן נכנס לתמונה שירות הענן ההיברידי המנוהל שלנו – פתרון המשלב בין היתרונות של ענן פרטי לענן ציבורי, ומעניק לך גישה לשרתי ענן מנוהלים (בדומה ל-EC2 או ECS) ללא כאבי הראש הכרוכים בניהול תשתית עצמאית.</p>
            </div>
          </div>

          <section className="cloud-what-is">
            <div className="section-content">
              <h2>מהו שירות ענן היברידי מנוהל?</h2>
              <p>ענן היברידי הוא מודל עבודה המשלב בין תשתיות ענן פרטיות לתשתיות ענן ציבוריות, כדי לספק לעסק שלך גמישות מקסימלית, סקלאביליות גבוהה, וחיסכון משמעותי בעלויות. כאשר הענן ההיברידי מנוהל במלואו על ידי צוות מומחים, אתה נהנה משילוב מושלם בין שני העולמות – מבלי לדאוג לטכנולוגיה, לאבטחה או לתחזוקה שוטפת.</p>
            </div>
          </section>

          <section className="cloud-benefits">
            <h2>יתרונות מרכזיים של שירות הענן ההיברידי המנוהל שלנו</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <div className="benefit-content">
                  <h3>גמישות וסקלביליות</h3>
                  <p>ניתן להוסיף או להסיר משאבים לפי הצורך העסקי, ולהתאים את התצורה למשתני התנועה והביצועים הרצויים בקלות ובמהירות.</p>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-content">
                  <h3>ניהול מלא</h3>
                  <p>הצוות המומחה שלנו דואג לכל ההיבטים הטכנולוגיים – החל מפריסת השרתים, דרך הגדרות אבטחה וגיבוי, ועד עדכוני תוכנה שוטפים.</p>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-content">
                  <h3>אבטחת מידע מתקדמת</h3>
                  <p>אנו משתמשים בטכנולוגיות המתקדמות ביותר ובתקני אבטחה מחמירים, כך שהמידע שלך מוגן בכל רגע נתון.</p>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-content">
                  <h3>חסכון בעלויות</h3>
              <p>במודל שלנו אתם נהנים מחיסכון לאורך זמן: ענן פרטי ייעודי נותן עלות צפויה ויעילה יותר מהרבה תרחישים של ענן ציבורי—במיוחד כשמדובר בעומסים קבועים ופרודקשן שרץ 24/7.</p>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-content">
                  <h3>זמינות ושרידות גבוהה</h3>
                  <p>עם שכבת HA אופציונלית וניהול תפעולי מקצועי, המערכת נשארת זמינה גם בעומסים, שדרוגים ותקלות נקודתיות.</p>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-content">
                  <h3>תמיכה מקצועית</h3>
                  <p>אנו מספקים שירותי תמיכה, עם מומחים שמלווים אותך בכל שלב – מההטמעה ועד לתחזוקה השוטפת.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="cloud-suitable">
            <h2>למי זה מתאים?</h2>
            <ul>
              <li>חברות וארגונים בצמיחה המעוניינים להגביר את יכולות הדיגיטל והדאטה שלהם במהירות וביעילות.</li>
              <li>סטארטאפים טכנולוגיים שמחפשים תשתית מהירה להטמעה, עם אפשרות להתרחב באופן גמיש ללא השקעה כבדה מראש.</li>
              <li>ארגוני אנטרפרייז המעוניינים לנהל עומסי עבודה גדולים ומורכבים בסביבת ענן מאובטחת.</li>
              <li>גופים פיננסיים וביטחוניים שזקוקים לפתרונות אבטחה ורגולציה מחמירים.</li>
              <li>כל עסק שרוצה לשלב בין ענן ציבורי לענן פרטי ולהתמקד בפעילות הליבה העסקית.</li>
            </ul>
          </section>

          <section className="cloud-process">
            <h2>כיצד זה עובד?</h2>
            <div className="process-steps">
              <div className="step">
                <h3>אפיון וייעוץ</h3>
                <p>בשלב הראשון אנחנו לומדים את הצרכים והמטרות העסקיות שלך, ומבצעים אפיון ראשוני של תשתית הענן ההיברידית.</p>
              </div>
              <div className="step">
                <h3>פריסה והקמה</h3>
                <p>נקים עבורך את סביבת הענן ההיברידית, נדאג לקישור מאובטח בין הענן הציבורי לענן הפרטי, ונגדיר את השרתים המנוהלים בהתאם לדרישותיך.</p>
              </div>
              <div className="step">
                <h3>אינטגרציות והתאמות</h3>
                <p>נבצע חיבור למערכות קיימות, נשלב אוטומציות ותהליכי CI/CD בהתאם לצורך, ונגדיר מנגנוני גיבוי והתאוששות מאסון.</p>
              </div>
              <div className="step">
                <h3>ניהול שוטף ותמיכה</h3>
                <p>אנחנו ננהל את התשתית מקצה לקצה: ניטור והתראות, עדכוני אבטחה, טיפול בתקלות, שדרוגים ושינויים נדרשים.</p>
              </div>
            </div>
          </section>

          <section className="cloud-why-us">
            <h2>למה לבחור דווקא בנו?</h2>
            <ul>
              <li>התאמה אישית מלאה: אנו בונים את הפתרון באופן גמיש כדי לתת מענה מדויק לצרכי הארגון שלך.</li>
              <li>שירות מקצה לקצה: ליווי צמוד בכל שלבי הפרויקט – מייעוץ והטמעה ועד לתחזוקה ובקרה.</li>
            </ul>
          </section>

          <section className="cloud-infrastructure">
            <div className="infrastructure-header">
              <img src="../arc.png" alt="תשתית ענן היברידי" className="infrastructure-image" />
              <h2>תשתית ענן היברידי ייעודית מנוהלת (Single-Tenant)</h2>
            </div>
            
            <div className="infrastructure-layers">
              <div className="layer-item">
                <h3>שכבת חוות השרתים (Data Center)</h3>
                <p>אינטרנט וקישוריות + חומרה (שרתים/דיסקים/רכיבים) + טיפול תקלות והחלפות.</p>
              </div>

              <div className="layer-item">
                <h3>שכבת Hypervisor מנוהל (IaaS)</h3>
                <p>הקמה וניהול Hypervisor: עדכונים, הרשאות, Hardening בסיסי, וניהול תצורת Host/Network.</p>
              </div>

              <div className="layer-item">
                <h3>וירטואליזציה ומכונות וירטואליות (VMs)</h3>
                <p>הקמה וניהול VMs לפי סביבות (Prod/Stage/Management), הפרדה בין רכיבים, והקצאת משאבים מבוקרת.</p>
              </div>

              <div className="layer-item">
                <h3>גיבויים ושחזורים (VM Backups) – מקומי ומרוחק</h3>
                <p>מערכת גיבוי מתקדמת המבטיחה שמירת המידע במיקומים שונים להבטחת זמינות ושחזור מהיר במקרה אסון.</p>
              </div>

              <div className="layer-item">
                <h3>שכבת PaaS מנוהלת לקונטיינרים (כולל CI/CD ו-Rolling Updates)</h3>
                <p>פלטפורמה שמריצה ומנהלת את הקונטיינרים של האפליקציות ברמת Production, ניהול Secrets/ENV, Volumes/Storage ו-Health Checks.</p>
                <p>מובנה תהליך CI/CD מלא — כל שינוי בקוד בונה אוטומטית קונטיינר חדש ומבצע Deploy לפרודקשן.</p>
                <p>במקרה תקלה אפשר לבצע Rollback מהיר לגרסה קודמת.</p>
              </div>

              <div className="layer-item">
                <h3>ניטור והתראות בכל שכבה</h3>
                <p>Monitoring + Alerts לתשתית, Hypervisor, VMs, וה-PaaS/Services.</p>
                <p>אפשרות לניטור סייבר ברמת קונטיינרים.</p>
                <p>מתאימה להרצת ריבוי אפליקציות או ארכיטקטורת <span className="highlight-text">Microservices</span>, עם בידוד בין שירותים ויכולת להתרחב לפי צורך.</p>
              </div>
            </div>
          </section>

          <section className="cloud-cta">
            <h2>התקדם עוד היום לענן היברידי מנוהל</h2>
            <p>אל תישאר מאחור בעידן הדיגיטלי. הגבלות תשתית וחששות טכניים לא צריכים לעכב את הצלחת הארגון שלך.</p>
            <a href="/contact1" className="contact-button">צור קשר</a>
          </section>

          <div className="cloud-closing">
            <p>הצטרף עוד היום לעולם של ענן היברידי מנוהל ותהנה מכל היתרונות של הענן המתקדם – עם אפס התעסקות טכנית ומקסימום תוצאות עסקיות!</p>
          </div>
        </div>
      </main>
    </>
  );
};

export default Cloud;
